import { root, id } from './roles';

export const roles = {
  ...root,
  id,
};
